var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path, _g10, _g11, _path2, _path3, _g12, _g13, _g14, _g15, _g16, _g17, _path4, _g18, _g19, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaithingAproval(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 322.5,
    height: 283.199,
    viewBox: "0 0 322.5 283.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.184,73.313a24.9,24.9,0,1,0,24.9-24.9,24.9,24.9,0,0,0-24.9,24.9",
    fill: "#d7e3f4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 315.5,
    height: 283.199,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.973,118.094c-6.929,5.661-11.356,24.08-11.356,24.08l7.46,3.05s.018-.034.051-.092c.161-.271.685-1.141,1.462-2.476,1.259-2.172,3.194-5.543,5.34-9.472a37.25,37.25,0,0,0,3.878-9.159c.82-4.03-2-5.585-5.915-6.329a6.919,6.919,0,0,0-.92.4",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -3.346,
    y1: 6.012,
    x2: -3.294,
    y2: 6.012,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e38204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#e38204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e35802"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.829,173.3c-7.809,11.871,3.983,42.484,4.061,43.734s-1.406,10.778-1.406,16.869S76.919,270,76.919,270l7.562-.156S88.7,225.94,88.7,221.255s.312-21.555.312-21.555,6.872,14.682,7.5,18.118-1.705,21.684,3.933,52.34c0,.032,7.313,0,7.313,0s1.557-42.46,1.765-50.583-8.95-46.689-8.95-46.689-8.061-6.631-16.494-6.631c-4.331,0-8.761,1.75-12.246,7.048",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -0.329,
    y1: 1.867,
    x2: -0.32,
    y2: 1.867,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008bec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077ec"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.127,116.851c-3.768.448-8.035,6.98-4.825,24.149,3.913,20.878-.676,26.159-1.157,32.1-.068.871,30,.144,30,.144-.042-.211-2.99-21.765.322-31.753,1.224-3.7,1.917-5.9,2.306-7.367.143-.516.237-.938.313-1.3a8.344,8.344,0,0,0,.177-1.943c-.059-3.7-3.016-7.157-4.808-8.821-1.631-1.516-12.641-5.322-20.2-5.322a18.06,18.06,0,0,0-2.119.116",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -1.964,
    y1: 2.908,
    x2: -1.936,
    y2: 2.908,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.576,120.476c-4.04.3-8.68.169-10.852,1.132-3.76,1.664-2.557,8.061,1.271,9.565.058.026.16.009.177.068.744,2.23,4.116,2.623,7.875,1.588,6.141-1.689,14.093-4.749,14.093-4.749l-.1-.464-1.741-7.833s-2.853.108-10.722.693",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -3.347,
    y1: 11.604,
    x2: -3.31,
    y2: 11.604,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.324,281.539s17.471.8,17.376-.173-1.19-.408-5.37-3.022-4.872-4.623-4.872-4.623c0-.21-6.861-.224-6.861-.224Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -5.742,
    y1: 1.095,
    x2: -5.685,
    y2: 1.095,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.417,273.5v7.459s14.77.535,14.963-.292c.2-.861-2-.345-4.482-2.754A17.687,17.687,0,0,1,84.29,273.5H77.417",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: -5.105,
    y1: 1.212,
    x2: -5.039,
    y2: 1.212,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.495,
    height: 7.934,
    transform: "translate(71.128 137.197)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.624,142.58l-.034.076c-.777,1.335-1.3,2.2-1.462,2.475l.795-7.934a41.3,41.3,0,0,0,.7,5.383",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: -47.546,
    y1: 18.402,
    x2: -46.877,
    y2: 18.402,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.986,
    height: 1.88,
    transform: "translate(98.095 132.821)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.081,132.821c-.076.363-.169.785-.313,1.3-1.884,1.132-5.673.256-5.673.256l5.952-1.549s.008-.008.034-.008",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: -16.387,
    y1: 61.788,
    x2: -16.22,
    y2: 61.788,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.46,193.461c-.959.109-2.058,2.747-2.358,3.5a22.218,22.218,0,0,0-1.026,3.337l1.189,1.632s-.686-.032-1.494-.078a52.212,52.212,0,0,0-.6,6.418c-.169,3.814.045,7.689,2.028,11.067.128.216.261.43.4.639,1.817-.373,3.9-1.029,3.9-1.029l-2.2,3.271a20.7,20.7,0,0,1,3.868,5.685c1.113,2.981.712,6.252.584,9.419,1.56.61,3.327,1.334,3.327,1.334l-3.355-.285c-.027,4.7,2.5,8.61,5.117,12.389l2.288-2.486-1.1,4.2c.655.948,1.289,1.892,1.867,2.847,3.749,6.2,4.011,13.957,8.411,19.83,1.009,1.348,2.812,2.648,4.237,1.745a3.564,3.564,0,0,0,1.217-2.943,17.437,17.437,0,0,0-.135-3.178,40.046,40.046,0,0,1,.1-11.32,16.34,16.34,0,0,0-.306-7.132,16.767,16.767,0,0,0-1.135-2.807l-1.72.168s.307-.978.661-2.093c-2.059-3.507-4.59-6.9-4.683-10.942a9.442,9.442,0,0,1,.756-3.774l-1.13-2.241,1.623,1.1c.421-.9.889-1.787,1.314-2.715a9.58,9.58,0,0,0,.641-7.354l-6.109-1.906s2.1-.734,4.31-1.336c-2.9-3.78-7.88-6.79-10.706-10.652-.123-.169-.238-.337-.349-.509l-2.3-.3,1.346-1.426c-1.057-2.309-1.486-4.774-2.422-7.24s-3.042-4.85-5.6-4.85a4.075,4.075,0,0,0-.465.026",
    fill: "#f88436"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.407,
    height: 64.502,
    transform: "translate(249.8 201.17)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.286,265.672c-.9-9.723-3.567-13.983-5.918-17.742a24.39,24.39,0,0,1-2.852-5.579,31.866,31.866,0,0,1-.929-8.316c-.151-5.049-.307-10.271-3.419-13.645-5.307-5.754-6.366-19.077-6.368-19.2l.925-.016-.462.008.462-.01c0,.124.994,13.032,6.123,18.592,3.346,3.629,3.508,9.026,3.664,14.246a31.264,31.264,0,0,0,.886,8.062,23.29,23.29,0,0,0,2.755,5.37c2.286,3.655,5.132,8.2,6.054,18.146Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.557,186.97a10.585,10.585,0,0,0-6.7,3.756c-4.356,5.339-3.98,12.906-7.225,18.805-1.639,2.979-4.166,5.193-6.575,7.538-2.162,2.1-4.443,4.626-4.9,7.726-.264,1.8-.052,3.665-.471,5.437-.586,2.474-2.3,4.406-3.853,6.331a36.825,36.825,0,0,0-4.1,6.647c-3.02,5.918-6,13.473-4.2,20.145a9.2,9.2,0,0,0,3.1,5.066c3.6,2.7,9.556,1.429,13.267-.423a10.533,10.533,0,0,0,4.049-3.225c2.775-4.132,2.469-9.683,3.248-14.4.927-5.608,3.43-11.146,7.866-14.7,3.6-2.883,6.015-6.085,6.769-10.782.742-4.618.259-9.321.759-13.959a72.625,72.625,0,0,1,2.94-14.305c1.177-3.707,2.419-9.745-2.836-9.746a8.4,8.4,0,0,0-1.137.083",
    fill: "#f88436"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.609,
    height: 45.221,
    transform: "translate(269.816 216.538)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.874,225.654a.6.6,0,0,1,.678.511l1.727,12.307,10.986-21.606a.6.6,0,1,1,1.069.543l-8.034,15.8,11.181-7.832a.6.6,0,0,1,.688.983l-12.7,8.894a.586.586,0,0,1-.26.1L273.73,255.964l7.674-3.48a.6.6,0,0,1,.5,1.093l-8.582,3.892a.6.6,0,0,1-.373.039l-1.995,3.923a.6.6,0,1,1-1.069-.544L280.4,240.2a.6.6,0,0,1-.136-.3l-1.9-13.564a.6.6,0,0,1,.511-.678",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.723,250.411l2.785,28.614a2.708,2.708,0,0,0,2.7,2.479h21.837a2.708,2.708,0,0,0,2.7-2.479l2.785-28.614Z",
    fill: "#0c1151"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.799,
    height: 5.563,
    rx: 1.177,
    transform: "translate(253.726 250.411)",
    fill: "#0c1151"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.749,168.171A68.145,68.145,0,1,1,123.6,100.026a68.144,68.144,0,0,1,68.145,68.145",
    fill: "#eff4f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.926,102.206a51.79,51.79,0,1,1-51.79-51.79,51.79,51.79,0,0,1,51.79,51.79",
    fill: "#eff4f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.965,142a51.79,51.79,0,1,1-51.79-51.79A51.79,51.79,0,0,1,296.965,142",
    fill: "#eff4f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.849,1.09H0V-1.09H277.849Z",
    transform: "translate(37.651 282.109)",
    fill: "#d7e3f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.766,210.6H128.393a8.662,8.662,0,0,1-8.662-8.662V79.652a8.662,8.662,0,0,1,8.662-8.662H265.766a8.662,8.662,0,0,1,8.662,8.662V201.939a8.662,8.662,0,0,1-8.662,8.662",
    fill: "#0c1151"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(143.5 129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.532,157.921l.657-.041a.506.506,0,0,0,.087.245.364.364,0,0,0,.3.136.336.336,0,0,0,.228-.07.209.209,0,0,0,.08-.162.206.206,0,0,0-.076-.156.879.879,0,0,0-.353-.13,1.5,1.5,0,0,1-.647-.273.55.55,0,0,1-.195-.434.591.591,0,0,1,.1-.327.663.663,0,0,1,.3-.242,1.4,1.4,0,0,1,.549-.088,1.118,1.118,0,0,1,.653.16.692.692,0,0,1,.267.509l-.65.038a.353.353,0,0,0-.109-.221.349.349,0,0,0-.229-.069.276.276,0,0,0-.181.051.158.158,0,0,0-.061.125.125.125,0,0,0,.05.1.562.562,0,0,0,.232.083,2.893,2.893,0,0,1,.648.2.683.683,0,0,1,.285.249.634.634,0,0,1,.089.332.715.715,0,0,1-.119.4.744.744,0,0,1-.332.277,1.336,1.336,0,0,1-.538.094,1.1,1.1,0,0,1-.789-.221.872.872,0,0,1-.248-.561",
    transform: "translate(-225.892 -138.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.6,162.554a.816.816,0,0,1,.25-.614,1.079,1.079,0,0,1,1.409.042.89.89,0,0,1-.048,1.177.942.942,0,0,1-.685.24.957.957,0,0,1-.631-.2.8.8,0,0,1-.3-.647m.621,0a.492.492,0,0,0,.088.322.286.286,0,0,0,.44,0,.509.509,0,0,0,.086-.329.481.481,0,0,0-.087-.315.27.27,0,0,0-.215-.1.28.28,0,0,0-.224.1.487.487,0,0,0-.088.319",
    transform: "translate(-242.752 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.461,162.726l.59.067a.836.836,0,0,1-.16.321.744.744,0,0,1-.284.211,1.111,1.111,0,0,1-.44.075,1.614,1.614,0,0,1-.429-.048.747.747,0,0,1-.295-.156.787.787,0,0,1-.193-.253.9.9,0,0,1-.07-.386.914.914,0,0,1,.085-.418.755.755,0,0,1,.171-.22.785.785,0,0,1,.222-.145,1.228,1.228,0,0,1,.465-.075,1.067,1.067,0,0,1,.6.142.751.751,0,0,1,.292.417l-.583.078a.272.272,0,0,0-.1-.157.323.323,0,0,0-.194-.053.313.313,0,0,0-.249.111.505.505,0,0,0-.1.336.438.438,0,0,0,.094.3.311.311,0,0,0,.241.1.329.329,0,0,0,.2-.063.374.374,0,0,0,.124-.193",
    transform: "translate(-258.289 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.583,156.708h.62v.424h-.62Zm0,.619h.62v1.627h-.62Z",
    transform: "translate(-274.557 -138.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.17,162.7h-1.243a.405.405,0,0,0,.081.224.293.293,0,0,0,.235.106.352.352,0,0,0,.174-.046.413.413,0,0,0,.108-.1l.611.057a.877.877,0,0,1-.338.352,1.221,1.221,0,0,1-.568.107,1.157,1.157,0,0,1-.506-.091.744.744,0,0,1-.305-.29.878.878,0,0,1-.121-.467.822.822,0,0,1,.243-.617.923.923,0,0,1,.671-.236,1.188,1.188,0,0,1,.548.106.712.712,0,0,1,.306.306,1.126,1.126,0,0,1,.105.522Zm-.631-.3a.418.418,0,0,0-.1-.259.3.3,0,0,0-.443.04.434.434,0,0,0-.072.219Z",
    transform: "translate(-281.376 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.639,156.708v2.246h-.58v-.241a.782.782,0,0,1-.222.207.633.633,0,0,1-.3.07.576.576,0,0,1-.5-.253,1.055,1.055,0,0,1-.174-.614.9.9,0,0,1,.193-.619.63.63,0,0,1,.49-.214.679.679,0,0,1,.263.049.6.6,0,0,1,.209.147v-.778Zm-.621,1.428a.43.43,0,0,0-.081-.286.257.257,0,0,0-.2-.094.224.224,0,0,0-.181.09.488.488,0,0,0-.073.3.46.46,0,0,0,.075.292.232.232,0,0,0,.187.093.249.249,0,0,0,.2-.094.47.47,0,0,0,.079-.3",
    transform: "translate(-296.901 -138.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.074,162.263l-.592-.063a.671.671,0,0,1,.1-.246.534.534,0,0,1,.182-.156.76.76,0,0,1,.235-.074,1.881,1.881,0,0,1,.323-.026,2.559,2.559,0,0,1,.448.031.575.575,0,0,1,.282.131.46.46,0,0,1,.125.2.709.709,0,0,1,.046.241v.719a.875.875,0,0,0,.014.18.809.809,0,0,0,.063.166h-.582a.6.6,0,0,1-.046-.1.714.714,0,0,1-.021-.1.8.8,0,0,1-.242.168,1,1,0,0,1-.382.067.637.637,0,0,1-.44-.135.429.429,0,0,1-.15-.332.437.437,0,0,1,.108-.3.73.73,0,0,1,.4-.178q.349-.071.452-.1a2.1,2.1,0,0,0,.219-.074.22.22,0,0,0-.047-.161.236.236,0,0,0-.166-.046.427.427,0,0,0-.228.049.269.269,0,0,0-.1.144m.538.328q-.128.046-.267.081a.617.617,0,0,0-.239.1.16.16,0,0,0,0,.235.214.214,0,0,0,.15.047.385.385,0,0,0,.193-.051.3.3,0,0,0,.126-.123.414.414,0,0,0,.037-.189Z",
    transform: "translate(-312.437 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.764,156.708v2.246h-.58v-.241a.781.781,0,0,1-.222.207.633.633,0,0,1-.3.07.575.575,0,0,1-.5-.253,1.055,1.055,0,0,1-.174-.614.9.9,0,0,1,.193-.619.63.63,0,0,1,.49-.214.68.68,0,0,1,.263.049.6.6,0,0,1,.209.147v-.778Zm-.622,1.428a.43.43,0,0,0-.081-.286.257.257,0,0,0-.2-.094.224.224,0,0,0-.181.09.488.488,0,0,0-.073.3.46.46,0,0,0,.075.292.232.232,0,0,0,.187.093.249.249,0,0,0,.2-.094.47.47,0,0,0,.079-.3",
    transform: "translate(-327.952 -138.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.42,162.7h-1.243a.405.405,0,0,0,.081.224.293.293,0,0,0,.235.106.352.352,0,0,0,.174-.046.413.413,0,0,0,.108-.1l.611.057a.877.877,0,0,1-.338.352,1.221,1.221,0,0,1-.568.107,1.157,1.157,0,0,1-.506-.091.744.744,0,0,1-.305-.29.878.878,0,0,1-.121-.467.822.822,0,0,1,.243-.617.923.923,0,0,1,.671-.236,1.188,1.188,0,0,1,.548.106.712.712,0,0,1,.306.306,1.126,1.126,0,0,1,.105.522Zm-.631-.3a.418.418,0,0,0-.1-.259.3.3,0,0,0-.443.04.433.433,0,0,0-.072.219Z",
    transform: "translate(-343.477 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.7,156.708h1.147a.782.782,0,0,1,.561.179.674.674,0,0,1,.187.51.7.7,0,0,1-.2.532.877.877,0,0,1-.621.191h-.378v.833H415.7Zm.693.958h.169a.433.433,0,0,0,.28-.07.225.225,0,0,0,.081-.178.25.25,0,0,0-.07-.179.362.362,0,0,0-.264-.074h-.2Z",
    transform: "translate(-367.481 -138.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.065,162.554a.816.816,0,0,1,.25-.614,1.079,1.079,0,0,1,1.409.042.89.89,0,0,1-.048,1.177.942.942,0,0,1-.685.24.957.957,0,0,1-.631-.2.8.8,0,0,1-.3-.647m.621,0a.493.493,0,0,0,.088.322.286.286,0,0,0,.44,0,.509.509,0,0,0,.086-.329.482.482,0,0,0-.087-.315.27.27,0,0,0-.215-.1.28.28,0,0,0-.224.1.487.487,0,0,0-.088.319",
    transform: "translate(-382.832 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.336,161.736h.58V162a.637.637,0,0,1,.173-.238.363.363,0,0,1,.22-.065.652.652,0,0,1,.3.086l-.192.444a.485.485,0,0,0-.174-.046.214.214,0,0,0-.189.1,1.033,1.033,0,0,0-.1.533v.546h-.623Z",
    transform: "translate(-398.984 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.154,156.708v.619h.341v.456h-.341v.576a.313.313,0,0,0,.02.138.113.113,0,0,0,.107.052.679.679,0,0,0,.192-.04l.046.43a2.007,2.007,0,0,1-.43.051.743.743,0,0,1-.341-.06.363.363,0,0,1-.162-.181,1.072,1.072,0,0,1-.053-.394v-.572H463.3v-.456h.228v-.3Z",
    transform: "translate(-409.564 -138.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.4,163.64h-.579v-.264a.854.854,0,0,1-.261.231.691.691,0,0,1-.324.069.526.526,0,0,1-.4-.154.67.67,0,0,1-.145-.474v-1.036h.623v.895a.33.33,0,0,0,.056.217.2.2,0,0,0,.158.064.225.225,0,0,0,.182-.086.5.5,0,0,0,.071-.308v-.783h.62Z",
    transform: "translate(-420.515 -143.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.852,161.736h.58v1.609a.682.682,0,0,1-.065.292.614.614,0,0,1-.172.224.676.676,0,0,1-.273.124,1.69,1.69,0,0,1-.378.038,1.109,1.109,0,0,1-.67-.147.48.48,0,0,1-.182-.394c0-.02,0-.048,0-.083l.6.069a.2.2,0,0,0,.07.116.3.3,0,0,0,.172.047.259.259,0,0,0,.2-.072.371.371,0,0,0,.066-.251v-.247a.6.6,0,0,1-.492.234.612.612,0,0,1-.524-.285.913.913,0,0,1-.142-.535.827.827,0,0,1,.183-.579.619.619,0,0,1,.478-.2.667.667,0,0,1,.311.064.681.681,0,0,1,.229.213Zm-.583.789a.387.387,0,0,0,.075.261.264.264,0,0,0,.391,0,.39.39,0,0,0,.078-.266.4.4,0,0,0-.082-.272.257.257,0,0,0-.2-.094.232.232,0,0,0-.19.087.457.457,0,0,0-.071.287",
    transform: "translate(-435.506 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.528,163.64h-.579v-.264a.853.853,0,0,1-.261.231.692.692,0,0,1-.324.069.526.526,0,0,1-.4-.154.67.67,0,0,1-.145-.474v-1.036h.623v.895a.33.33,0,0,0,.056.217.2.2,0,0,0,.158.064.225.225,0,0,0,.182-.086.5.5,0,0,0,.071-.308v-.783h.62Z",
    transform: "translate(-451.566 -143.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.636,162.7h-1.243a.405.405,0,0,0,.081.224.293.293,0,0,0,.235.106.353.353,0,0,0,.174-.046.414.414,0,0,0,.108-.1l.611.057a.878.878,0,0,1-.338.352,1.222,1.222,0,0,1-.568.107,1.157,1.157,0,0,1-.506-.091.744.744,0,0,1-.305-.29.878.878,0,0,1-.121-.467.822.822,0,0,1,.243-.617.923.923,0,0,1,.671-.236,1.188,1.188,0,0,1,.548.106.712.712,0,0,1,.306.306,1.125,1.125,0,0,1,.105.522Zm-.631-.3a.418.418,0,0,0-.1-.259.3.3,0,0,0-.443.04.433.433,0,0,0-.072.219Z",
    transform: "translate(-466.545 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.049,162.91l.615-.058a.305.305,0,0,0,.107.158.315.315,0,0,0,.183.047.308.308,0,0,0,.193-.054.12.12,0,0,0,.053-.1.114.114,0,0,0-.07-.1,1.271,1.271,0,0,0-.267-.064,2.749,2.749,0,0,1-.449-.1.473.473,0,0,1-.212-.163.424.424,0,0,1-.086-.262.43.43,0,0,1,.093-.277.553.553,0,0,1,.256-.174,1.353,1.353,0,0,1,.437-.057,1.505,1.505,0,0,1,.427.044.557.557,0,0,1,.23.138.724.724,0,0,1,.153.253l-.588.058a.2.2,0,0,0-.076-.115.31.31,0,0,0-.177-.049.249.249,0,0,0-.153.037.112.112,0,0,0-.048.091.1.1,0,0,0,.061.09.986.986,0,0,0,.265.055,1.8,1.8,0,0,1,.46.1.508.508,0,0,1,.231.179.442.442,0,0,1,.08.256.506.506,0,0,1-.085.274.573.573,0,0,1-.267.212,1.275,1.275,0,0,1-.5.079,1.171,1.171,0,0,1-.631-.127.572.572,0,0,1-.242-.362",
    transform: "translate(-481.827 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.031,162.263l-.592-.063a.672.672,0,0,1,.1-.246.534.534,0,0,1,.182-.156.76.76,0,0,1,.235-.074,1.882,1.882,0,0,1,.323-.026,2.558,2.558,0,0,1,.448.031.575.575,0,0,1,.282.131.461.461,0,0,1,.125.2.709.709,0,0,1,.046.241v.719a.878.878,0,0,0,.014.18.809.809,0,0,0,.063.166h-.582a.6.6,0,0,1-.046-.1.707.707,0,0,1-.021-.1.8.8,0,0,1-.242.168,1,1,0,0,1-.382.067.637.637,0,0,1-.44-.135.429.429,0,0,1-.15-.332.437.437,0,0,1,.108-.3.731.731,0,0,1,.4-.178q.349-.071.452-.1a2.114,2.114,0,0,0,.219-.074.22.22,0,0,0-.047-.161.236.236,0,0,0-.166-.046.428.428,0,0,0-.229.049.269.269,0,0,0-.1.144m.538.328q-.128.046-.267.081a.616.616,0,0,0-.239.1.16.16,0,0,0,0,.235.214.214,0,0,0,.15.047.385.385,0,0,0,.193-.051.3.3,0,0,0,.126-.123.415.415,0,0,0,.037-.189Z",
    transform: "translate(-496.273 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.313,156.708v2.246h-.58v-.241a.781.781,0,0,1-.222.207.632.632,0,0,1-.3.07.575.575,0,0,1-.5-.253,1.055,1.055,0,0,1-.174-.614.9.9,0,0,1,.193-.619.63.63,0,0,1,.49-.214.68.68,0,0,1,.263.049.6.6,0,0,1,.209.147v-.778Zm-.622,1.428a.43.43,0,0,0-.081-.286.257.257,0,0,0-.2-.094.224.224,0,0,0-.181.09.488.488,0,0,0-.073.3.46.46,0,0,0,.075.292.232.232,0,0,0,.187.093.249.249,0,0,0,.2-.094.47.47,0,0,0,.079-.3",
    transform: "translate(-519.382 -138.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.969,162.7h-1.243a.4.4,0,0,0,.081.224.293.293,0,0,0,.234.106.353.353,0,0,0,.174-.046.414.414,0,0,0,.108-.1l.611.057a.877.877,0,0,1-.338.352,1.221,1.221,0,0,1-.568.107,1.157,1.157,0,0,1-.506-.091.744.744,0,0,1-.305-.29.878.878,0,0,1-.121-.467.822.822,0,0,1,.243-.617.923.923,0,0,1,.671-.236,1.188,1.188,0,0,1,.548.106.712.712,0,0,1,.306.306,1.125,1.125,0,0,1,.105.522Zm-.631-.3a.418.418,0,0,0-.1-.259.3.3,0,0,0-.443.04.432.432,0,0,0-.072.219Z",
    transform: "translate(-534.908 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.941,158.583h-.783l-.109.371h-.7l.839-2.246h.753l.839,2.246h-.723Zm-.143-.486-.247-.807-.244.807Z",
    transform: "translate(-557.228 -138.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.463,161.736h.577V162a.863.863,0,0,1,.262-.232.687.687,0,0,1,.323-.07.527.527,0,0,1,.4.154.673.673,0,0,1,.146.476v1.034h-.623v-.895a.328.328,0,0,0-.056-.217.2.2,0,0,0-.158-.064.225.225,0,0,0-.183.086.5.5,0,0,0-.07.308v.781h-.62Z",
    transform: "translate(-576.782 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.01,162.263l-.593-.063a.672.672,0,0,1,.1-.246.535.535,0,0,1,.182-.156.761.761,0,0,1,.235-.074,1.882,1.882,0,0,1,.323-.026,2.56,2.56,0,0,1,.448.031.576.576,0,0,1,.282.131.461.461,0,0,1,.125.2.709.709,0,0,1,.046.241v.719a.878.878,0,0,0,.014.18.812.812,0,0,0,.063.166h-.582a.6.6,0,0,1-.046-.1.7.7,0,0,1-.021-.1.8.8,0,0,1-.242.168,1,1,0,0,1-.382.067.637.637,0,0,1-.44-.135.43.43,0,0,1-.15-.332.437.437,0,0,1,.108-.3.73.73,0,0,1,.4-.178q.349-.071.452-.1a2.1,2.1,0,0,0,.219-.074.22.22,0,0,0-.047-.161.236.236,0,0,0-.166-.046.428.428,0,0,0-.229.049.269.269,0,0,0-.1.144m.538.328q-.128.046-.267.081a.616.616,0,0,0-.239.1.16.16,0,0,0,0,.235.214.214,0,0,0,.15.047.385.385,0,0,0,.193-.051.3.3,0,0,0,.126-.123.415.415,0,0,0,.037-.189Z",
    transform: "translate(-591.727 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.1,156.708v.619h.341v.456H687.1v.576a.313.313,0,0,0,.02.138.114.114,0,0,0,.107.052.677.677,0,0,0,.192-.04l.046.43a2.008,2.008,0,0,1-.43.051.743.743,0,0,1-.341-.06.362.362,0,0,1-.162-.181,1.071,1.071,0,0,1-.053-.394v-.572h-.229v-.456h.229v-.3Z",
    transform: "translate(-606.649 -138.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.033,162.554a.816.816,0,0,1,.25-.614,1.079,1.079,0,0,1,1.409.042.89.89,0,0,1-.048,1.177.942.942,0,0,1-.685.24.957.957,0,0,1-.631-.2.8.8,0,0,1-.3-.647m.622,0a.492.492,0,0,0,.088.322.286.286,0,0,0,.44,0,.509.509,0,0,0,.086-.329.482.482,0,0,0-.087-.315.27.27,0,0,0-.215-.1.28.28,0,0,0-.224.1.487.487,0,0,0-.088.319",
    transform: "translate(-617.066 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.291,161.736h.579v.238a.813.813,0,0,1,.252-.212.689.689,0,0,1,.307-.063.586.586,0,0,1,.307.069.512.512,0,0,1,.185.205.934.934,0,0,1,.266-.217.686.686,0,0,1,.3-.057.53.53,0,0,1,.406.156.692.692,0,0,1,.146.486v1.022h-.621v-.927a.261.261,0,0,0-.043-.164.186.186,0,0,0-.155-.084.219.219,0,0,0-.176.08.4.4,0,0,0-.067.256v.84h-.622v-.9a.571.571,0,0,0-.012-.146.2.2,0,0,0-.069-.1.183.183,0,0,0-.115-.037.22.22,0,0,0-.176.081.412.412,0,0,0-.069.267v.83h-.621Z",
    transform: "translate(-633.206 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.968,156.708h.62v.424h-.62Zm0,.619h.62v1.627h-.62Z",
    transform: "translate(-656.789 -138.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.334,162.263l-.593-.063a.672.672,0,0,1,.1-.246.535.535,0,0,1,.182-.156.76.76,0,0,1,.235-.074,1.882,1.882,0,0,1,.323-.026,2.56,2.56,0,0,1,.448.031.575.575,0,0,1,.282.131.46.46,0,0,1,.125.2.709.709,0,0,1,.046.241v.719a.877.877,0,0,0,.014.18.808.808,0,0,0,.063.166h-.582a.607.607,0,0,1-.046-.1.724.724,0,0,1-.021-.1.8.8,0,0,1-.242.168,1,1,0,0,1-.382.067.637.637,0,0,1-.439-.135.429.429,0,0,1-.15-.332.437.437,0,0,1,.108-.3.731.731,0,0,1,.4-.178q.349-.071.452-.1a2.11,2.11,0,0,0,.219-.074.22.22,0,0,0-.047-.161.236.236,0,0,0-.166-.046.427.427,0,0,0-.229.049.268.268,0,0,0-.1.144m.538.328q-.128.046-.267.081a.617.617,0,0,0-.239.1.16.16,0,0,0,0,.235.214.214,0,0,0,.15.047.385.385,0,0,0,.193-.051.3.3,0,0,0,.126-.123.415.415,0,0,0,.037-.189Z",
    transform: "translate(-663.618 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.835,156.708h1.147a.782.782,0,0,1,.561.179.674.674,0,0,1,.187.51.7.7,0,0,1-.2.532.877.877,0,0,1-.621.191h-.378v.833h-.693Zm.693.958h.169a.433.433,0,0,0,.28-.07.225.225,0,0,0,.081-.178.25.25,0,0,0-.07-.179.362.362,0,0,0-.263-.074h-.2Z",
    transform: "translate(-687.611 -138.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.076,162.263l-.592-.063a.674.674,0,0,1,.1-.246.534.534,0,0,1,.182-.156.76.76,0,0,1,.234-.074,1.882,1.882,0,0,1,.323-.026,2.556,2.556,0,0,1,.448.031.575.575,0,0,1,.282.131.46.46,0,0,1,.125.2.709.709,0,0,1,.046.241v.719a.872.872,0,0,0,.015.18.8.8,0,0,0,.063.166h-.582a.613.613,0,0,1-.046-.1.758.758,0,0,1-.021-.1.8.8,0,0,1-.242.168,1,1,0,0,1-.382.067.637.637,0,0,1-.44-.135.43.43,0,0,1-.15-.332.437.437,0,0,1,.108-.3.731.731,0,0,1,.4-.178q.348-.071.452-.1a2.11,2.11,0,0,0,.219-.074.22.22,0,0,0-.047-.161.235.235,0,0,0-.166-.046.427.427,0,0,0-.229.049.27.27,0,0,0-.1.144m.538.328q-.128.046-.267.081a.617.617,0,0,0-.239.1.157.157,0,0,0-.052.115.155.155,0,0,0,.051.12.214.214,0,0,0,.15.047.385.385,0,0,0,.193-.051.3.3,0,0,0,.127-.123.416.416,0,0,0,.037-.189Z",
    transform: "translate(-703.17 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.166,156.708v.619h.341v.456h-.341v.576a.313.313,0,0,0,.02.138.113.113,0,0,0,.107.052.678.678,0,0,0,.192-.04l.046.43a2.007,2.007,0,0,1-.43.051.743.743,0,0,1-.341-.06.363.363,0,0,1-.162-.181,1.073,1.073,0,0,1-.052-.394v-.572h-.229v-.456h.229v-.3Z",
    transform: "translate(-718.093 -138.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.1,162.554a.816.816,0,0,1,.25-.614,1.079,1.079,0,0,1,1.409.042.89.89,0,0,1-.048,1.177.942.942,0,0,1-.685.24.957.957,0,0,1-.631-.2.8.8,0,0,1-.3-.647m.621,0a.493.493,0,0,0,.088.322.286.286,0,0,0,.44,0,.51.51,0,0,0,.086-.329.482.482,0,0,0-.087-.315.27.27,0,0,0-.215-.1.28.28,0,0,0-.224.1.487.487,0,0,0-.088.319",
    transform: "translate(-728.51 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.621,
    height: 2.246,
    transform: "translate(97.725 18.282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.242,157.855a.817.817,0,0,1,.25-.614,1.079,1.079,0,0,1,1.409.042.89.89,0,0,1-.048,1.177.942.942,0,0,1-.685.24.956.956,0,0,1-.631-.2.8.8,0,0,1-.3-.647m.622,0a.492.492,0,0,0,.088.322.286.286,0,0,0,.44,0,.509.509,0,0,0,.086-.329.482.482,0,0,0-.087-.315.27.27,0,0,0-.215-.1.28.28,0,0,0-.224.1.487.487,0,0,0-.088.319m.291-1.474h.533l-.492.458h-.3Z",
    transform: "translate(-751.62 -138.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.007,161.736h.58v1.609a.682.682,0,0,1-.065.292.614.614,0,0,1-.172.224.676.676,0,0,1-.273.124,1.691,1.691,0,0,1-.379.038,1.109,1.109,0,0,1-.669-.147.48.48,0,0,1-.182-.394c0-.02,0-.048,0-.083l.6.069a.2.2,0,0,0,.07.116.3.3,0,0,0,.172.047.259.259,0,0,0,.2-.072.371.371,0,0,0,.066-.251v-.247a.6.6,0,0,1-.492.234.612.612,0,0,1-.524-.285.913.913,0,0,1-.142-.535.828.828,0,0,1,.183-.579.619.619,0,0,1,.478-.2.667.667,0,0,1,.311.064.681.681,0,0,1,.229.213Zm-.583.789a.387.387,0,0,0,.075.261.264.264,0,0,0,.391,0,.39.39,0,0,0,.078-.266.4.4,0,0,0-.082-.272.257.257,0,0,0-.2-.094.232.232,0,0,0-.19.087.457.457,0,0,0-.071.287",
    transform: "translate(-767.145 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.221,156.708h.62v.424h-.62Zm0,.619h.62v1.627h-.62Z",
    transform: "translate(-783.425 -138.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.241,162.726l.59.067a.836.836,0,0,1-.16.321.744.744,0,0,1-.284.211,1.112,1.112,0,0,1-.44.075,1.615,1.615,0,0,1-.429-.048.747.747,0,0,1-.295-.156.786.786,0,0,1-.193-.253.9.9,0,0,1-.07-.386.914.914,0,0,1,.085-.418.756.756,0,0,1,.171-.22.786.786,0,0,1,.222-.145,1.228,1.228,0,0,1,.465-.075,1.067,1.067,0,0,1,.6.142.751.751,0,0,1,.292.417l-.583.078a.272.272,0,0,0-.1-.157.323.323,0,0,0-.194-.053.313.313,0,0,0-.249.111.505.505,0,0,0-.1.336.438.438,0,0,0,.094.3.311.311,0,0,0,.241.1.329.329,0,0,0,.2-.063.374.374,0,0,0,.124-.193",
    transform: "translate(-790.267 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.15,162.263l-.593-.063a.672.672,0,0,1,.1-.246.535.535,0,0,1,.182-.156.76.76,0,0,1,.235-.074,1.883,1.883,0,0,1,.323-.026,2.56,2.56,0,0,1,.448.031.576.576,0,0,1,.282.131.461.461,0,0,1,.125.2.709.709,0,0,1,.046.241v.719a.873.873,0,0,0,.014.18.811.811,0,0,0,.063.166h-.582a.6.6,0,0,1-.046-.1.707.707,0,0,1-.021-.1.8.8,0,0,1-.242.168,1,1,0,0,1-.382.067.637.637,0,0,1-.44-.135.429.429,0,0,1-.15-.332.437.437,0,0,1,.108-.3.731.731,0,0,1,.4-.178q.349-.071.452-.1a2.11,2.11,0,0,0,.219-.074.22.22,0,0,0-.047-.161.236.236,0,0,0-.166-.046.428.428,0,0,0-.229.049.268.268,0,0,0-.1.144m.538.328q-.128.046-.267.081a.616.616,0,0,0-.239.1.16.16,0,0,0,0,.235.214.214,0,0,0,.15.047.385.385,0,0,0,.193-.051.305.305,0,0,0,.126-.123.415.415,0,0,0,.037-.189Z",
    transform: "translate(-805.78 -142.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.276,104.185v.01q0,.339-.5.583a2.672,2.672,0,0,1-1.2.25H256.5a1.128,1.128,0,0,1-1.158-1.095h6.831v-.954h-5.366a1.786,1.786,0,0,1-.961-.181.579.579,0,0,1-.388-.592V101.08a.579.579,0,0,1,.374-.6,1.76,1.76,0,0,1,.974-.243h5.539a.906.906,0,0,1,.93.879v.263h-6.612v.79h4.9a2.9,2.9,0,0,1,1.206.178q.484.247.491.6Z",
    transform: "translate(-225.723 -88.544)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.317,100.986v3.773h1.167v-1.982h5.3a2.542,2.542,0,0,0,1.2-.262q.5-.262.5-.633V100.8q0-.378-.491-.638a2.561,2.561,0,0,0-1.206-.259h-5.392A1.081,1.081,0,0,0,331.317,100.986Zm6.87.93h-5.7v-.8h5.7Z",
    transform: "translate(-292.886 -88.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.984,100.986v3.773h1.167v-1.982h5.3a2.542,2.542,0,0,0,1.2-.262q.5-.262.5-.633V100.8q0-.378-.491-.638a2.561,2.561,0,0,0-1.206-.259h-5.393A1.081,1.081,0,0,0,483.984,100.986Zm6.87.93h-5.7v-.8h5.7Z",
    transform: "translate(-427.845 -88.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.894,98.9a2.558,2.558,0,0,1,1.206.259q.49.259.491.637v3.007a1.067,1.067,0,0,1-1.064,1.07V101.83h-5.7v2.049a1.17,1.17,0,0,1-1.167-1.173V99.8q0-.378.491-.637a2.558,2.558,0,0,1,1.206-.259Zm.633,1.325h-5.7v.742h5.7Z",
    transform: "translate(-361.255 -87.366)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.627,41.928a5.5,5.5,0,0,1-7.8,0L4.4,37.471a5.581,5.581,0,0,1,0-7.852l1.492-1.5L13.5,35.775l3.527-3.548L9.416,24.571l-1.969-1.98L3.921,26.139l-1.492,1.5a8.4,8.4,0,0,0,0,11.812L6.856,43.9a8.279,8.279,0,0,0,11.743,0l7.049-7.436V32.819Z",
    transform: "translate(0 -19.955)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.01,0,.942,0,.932,3.521,0,3.524Z",
    transform: "translate(1.321 2.572) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.01,0,.942,0,.932,3.521,0,3.524Z",
    transform: "translate(13.911 17.232) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.01,0,.942,0,.932,3.521,0,3.524Z",
    transform: "translate(15.889 15.349) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.01,0,.942,0,.932,3.521,0,3.524Z",
    transform: "translate(18.054 13.23) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.01,0,.942,0,.932,3.521,0,3.524Z",
    transform: "translate(3.273 0.666) rotate(-45)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.791,
    height: 49.792,
    transform: "translate(172.184 48.417)",
    fill: "#d7e3f4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.46,175.933l25.795-1.073,1.13-44.13-3.205-8.938L86.5,118.113l-7.479-1.383a9,9,0,0,0-7.31,9.159l2.8,31.232Z",
    fill: "#f7d6b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.813,109.831V118.7s1.874,1.12,6.259,1.12c2.364,0,2.9.408,2.9.408V115.42Z",
    fill: "#f7d6b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.781,103.21c.021.321.031.622.052.912,0,.1-.01.207-.01.321-.218,5.264,3.16,10.9,8.248,11.668,0,0,.041.01.114.02.041,0,.1.011.176.011,1.088.134,5.025.456,6.466-1.13a13.4,13.4,0,0,0,3.191-7.62,29.962,29.962,0,0,0-.425-3.832c0-.735.4-3.037.4-4.037.034-4.7-3.128-9.359-8.744-9.359-8.424,0-9.709,7.388-9.471,13.046",
    fill: "#f7d6b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.006,153.779c2.766,1.15,10.938-14.3,13.919-21.112s4.113-12.716.736-14.12-6.765,3.558-9.5,10.476-7.926,23.606-5.16,24.756",
    fill: "#f7d6b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.055,184.515c2.656.042,3.695-19.493,3.783-25.012s-.228-11.351-3.206-11.4-3.478,5.772-3.565,11.291.332,25.077,2.988,25.119",
    fill: "#f7d6b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.265,179.458c-3.126-.282-3,5.287-2.883,7.185.184,3.092,3.386,6.106,4.586,6.052s.256-7.022.52-7.269.406,3.536,1.528,3.366.727-4.757-.128-6.514-1.664-2.643-3.623-2.82",
    fill: "#f7d6b2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.011,
    height: 27.528,
    transform: "translate(63.617 117.696)",
    fill: "url(#d)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.419,172.655c-2.573.975-4,5.056-3.134,8.852a56.414,56.414,0,0,0,4.048,11.434c5.342,11.323,9.475,26.464,13.264,26.41s5.045-9.445,1.332-21.679c-3.355-11.058-6.43-25.559-9.218-26.279-1.413-.365-4.042.409-6.292,1.262",
    fill: "#f7d6b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.845,216.936c-10.294-3.152-5.635,46.652-2.18,55.5s4.753-14.755,5.375-30.022.855-24.236-3.195-25.476",
    fill: "#f7d6b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.987,261.356c.117.156.859,13.745.859,13.745s6.56.469,6.56,0,.508-12.261.508-12.261Z",
    fill: "#f7d6b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.818,261.356c.117.156.859,13.745.859,13.745s6.56.469,6.56,0,.508-12.261.508-12.261Z",
    fill: "#f7d6b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9,172.475c-2.712.458-4.907,4.184-4.79,8.076a56.441,56.441,0,0,0,1.756,12c3.046,12.145,4.166,27.8,7.894,28.481s6.78-8.289,5.509-21.011c-1.149-11.5-1.355-26.319-3.952-27.567-1.316-.631-4.044-.381-6.417.019",
    fill: "#f7d6b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.182,218c-10.122-3.666-7.3,46.327-4.291,55.335s4.813-14.514,6.2-29.73,2.072-24.163-1.91-25.6",
    fill: "#f7d6b2"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.742,
    height: 47.572,
    transform: "translate(62.148 270.156) rotate(-88.968)",
    fill: "url(#g)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.175,
    height: 57.234,
    transform: "translate(69.092 116.735)",
    fill: "url(#i)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.18,121.866c-.4-2.943-17.718-2.178-25.041-1.308s-12.939,2.864-12.446,6.458,6.439,4,13.726,2.862,24.166-5.069,23.761-8.012",
    fill: "#eed7ba"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.176,
    height: 14.081,
    transform: "translate(90.964 119.783)",
    fill: "url(#l)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.406,96.608a9.251,9.251,0,0,1-1.35,4.115c-2.617,4.493-4.115,8.729-4.041,14.007.089,6.322,3.883,13.858-.036,19.708-5.708,8.52-20.374,7.911-26.754.8-4.266-4.755-5.248-12.453-.243-17.145,2.163-2.026,4.185-3.96,5.433-6.682,3.482-7.6,3.061-19.8,12.738-22.9,5.411-1.732,14.632,1.292,14.253,8.1",
    fill: "#1d262d"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.471,
    height: 8.846,
    transform: "translate(100.324 273.497)",
    fill: "url(#n)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.164,
    height: 7.994,
    transform: "translate(77.417 273.501)",
    fill: "url(#p)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.5,97c-1.885,1.84,11.14,16.216,14.963,20.133s8.149,7.768,10.262,5.7-1.633-6.48-5.457-10.4S107.386,95.162,105.5,97",
    fill: "#eed7ba"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.24,91.983c-.734.731,3.155,4.286,4.172,5.443.154.175.245.3.242.345s-.069.048-.165.022c-.6-.164-2.742-1.533-3.355-.78-.673.828,2.289,3.632,4.133,4.537.1.05.214.118.308.156,1.8.719,2.985.828,4.54-.35,2.48-1.879-1.331-5.878-2.681-7.194a9.7,9.7,0,0,0-4.247-2.239c-1.357-.343-2.539-.346-2.947.06",
    fill: "#eed7ba"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.496,
    height: 7.934,
    transform: "translate(71.128 137.197)",
    fill: "url(#t)"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.986,
    height: 2.433,
    transform: "translate(98.095 132.821)",
    fill: "url(#w)"
  })))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.027,
    height: 88.994,
    transform: "translate(226.786 197.11) rotate(-12.047)",
    fill: "#f88436"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.845,
    height: 67.653,
    transform: "translate(231.315 206.993) rotate(-17.486)",
    fill: "#fff"
  })))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.621,
    height: 75.613,
    transform: "matrix(0.393, -0.919, 0.919, 0.393, 230.282, 258.094)",
    fill: "#f88436"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.74,
    height: 45.392,
    transform: "translate(269.766 216.452)",
    fill: "#fff"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M276.216,209.274a18.455,18.455,0,0,1,4.9-5.592.483.483,0,0,0,.2-.27c2.766-2.216,10.172-8.615,6.441-10.842-3.7-2.207-6.37,6.865-7.24,10.327a19.145,19.145,0,0,0-5.084,5.755c.909-3.714,2.665-12.6-1.5-12.147-4.674.514-.252,11.028.788,13.357a36.7,36.7,0,0,0-2.486,5.463c-.17.467-.337.959-.5,1.469,0-4.1-.463-12.191-4.217-10.872-4.334,1.522,1.946,10.374,3.676,12.681a58.45,58.45,0,0,0-1.766,9.665c-.887-3.773-3.33-12.338-6.81-10.064-3.9,2.544,4.577,9.795,6.677,11.508a85.242,85.242,0,0,0-.243,9.016c-1.374-3.483-5.145-11.966-8.311-9.146-3.495,3.113,6.092,9.076,8.351,10.411.092,2.528.283,5.224.6,8.1-2.407-2.747-8.966-9.658-11.011-5.886-2.164,3.989,8.149,6.325,11.129,6.909.342,2.92.8,6.014,1.409,9.3-1.848-2.173-9.287-10.5-11.49-6.439-2.3,4.236,9.479,6.608,11.6,7,.4,2.1.846,4.278,1.363,6.537a.491.491,0,1,0,.958-.22q-.774-3.385-1.361-6.53c2.407-.239,14.195-1.638,12.025-5.869-2.112-4.117-10.135,3.447-12.114,5.409-.6-3.234-1.053-6.276-1.393-9.148,2.287-.225,14.266-1.614,12.08-5.875-2.119-4.132-10.189,3.5-12.132,5.427-.364-3.173-.582-6.128-.679-8.877,2.557-.131,14.174-.964,12.234-5.261-1.872-4.146-10.01,2.7-12.253,4.7a85.3,85.3,0,0,1,.223-9.487c2.57.127,14.191.462,12.694-4-1.441-4.3-10.181,1.645-12.642,3.427a58.276,58.276,0,0,1,1.824-10.367c2.739.134,14.088.428,12.615-3.99-1.391-4.168-9.64,1.266-12.4,3.229.244-.821.5-1.593.754-2.309a35.149,35.149,0,0,1,2.532-5.545c2.536.09,14.217.27,12.653-4.184-1.412-4.021-9.134,1.092-12.085,3.234",
    fill: "#1d262d"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#af)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.805,
    height: 31.093,
    transform: "translate(255.723 250.411)",
    fill: "#0c1151"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ag)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.799,
    height: 5.563,
    transform: "translate(253.726 250.411)",
    fill: "#0c1151"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9,3V9.626h.011L9,9.637l4.417,4.406L9,18.46l.011.011H9v6.615H22.252V18.471h-.011l.011-.011-4.417-4.417,4.417-4.406-.011-.011h.011V3ZM20.043,19.012v3.865H11.209V19.012L15.626,14.6Zm-4.417-5.521L11.209,9.074V5.209h8.834V9.074Z",
    transform: "translate(181.453 60.957)",
    fill: "#0c1151"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaithingAproval);
export default __webpack_public_path__ + "static/media/Waithing-Aproval.9e7f9f8e0fa1e8d30ff542658813b2f1.svg";
export { ForwardRef as ReactComponent };